// Settings translations for React Admin resource
export const settingsResource = {
  name: '設定',
  fields: {
    key: '鍵值',
    value: '數值',
    type: '類型',
    description: '描述',
    updatedAt: '更新時間',
  },
};

// Custom settings translations for components
export const settings = {
  logoUploaded: '標誌上傳成功',
  uploading: '上傳中...',
  changeLogo: '更換標誌',
  invalidFileType: '無效的檔案類型。僅允許 PNG、JPEG 和 SVG',
  fileTooLarge: '檔案過大。最大容量為 5MB',
  authRequired: '需要身份驗證。請重新登入。',
  noPermissionView: '您沒有權限查看設定。',
  noPermissionEdit: '您需要管理員權限才能編輯設定。',
  noSettings: '此類別沒有可用的設定。',
  translations: '翻譯',
  manageTranslations: '管理翻譯',
  originalValue: '原始值（英文）',
  traditionalChinese: '繁體中文',
  enterTranslation: '輸入繁體中文翻譯',
  cancel: '取消',
  saveTranslations: '儲存翻譯',
  categories: {
    branding: '品牌',
    appearance: '外觀',
    system: '系統',
    payment: '付款',
  },
  fields: {
    company_name: '公司名稱',
    company_logo: '公司標誌',
    theme_config: '主題設定',
    system_timezone: '系統時區',
    invoice_prefix: '發票前綴',
    database_version: '資料庫版本',
    maintenance_mode: '維護模式',
    maintenance_message: '維護訊息',
    mpay_callback_webhook_url: 'MPay 回呼 Webhook 網址',
    payment_retry_delay_minutes: '付款重試延遲分鐘數',
    payment_retry_max_attempts: '付款重試最大次數',
    payment_webhook_enabled: '付款 Webhook 啟用',
    payment_webhook_secret: '付款 Webhook 密鑰',
    payment_webhook_timeout: '付款 Webhook 逾時',
    payment_webhook_url: '付款 Webhook 網址',
    wallet_charge_decimal_places: '錢包收費小數位',
    rfid_charge_decimal_places: 'RFID 卡收費小數位',
  },
  descriptions: {
    company_name: '您的公司或組織名稱',
    company_logo: '顯示在管理介面的公司標誌',
    theme_config: '視覺主題和配色方案設定',
    system_timezone: '系統預設時區',
    invoice_prefix: '發票編號的前綴（例如：RCP、INV、EV）',
    database_version: '目前資料庫結構版本，對應遷移檔案編號',
    maintenance_mode: '啟用維護模式',
    maintenance_message: '維護期間顯示的訊息',
    mpay_callback_webhook_url: 'mPay 付款閘道回呼的 Webhook 網址',
    payment_retry_delay_minutes: '重試失敗付款前等待的分鐘數',
    payment_retry_max_attempts: '付款重試的最大次數',
    payment_webhook_enabled: '啟用/停用付款 Webhook 呼叫',
    payment_webhook_secret: '驗證 Webhook 請求的密鑰',
    payment_webhook_timeout: 'Webhook 逾時秒數',
    payment_webhook_url: '付款結算處理的 Webhook 網址',
    wallet_charge_decimal_places: '從 App 錢包收取的金額（App 充電及連結錢包的 RFID 卡）按此小數位四捨五入',
    rfid_charge_decimal_places: 'RFID 專用卡的收費金額按此小數位四捨五入',
  },
  decimalPlaces: {
    one: '1 位小數（最接近的 HK$0.10）',
    two: '2 位小數（準確至一仙）',
    choose: '小數位',
    edit: '更改小數位',
    save: '儲存小數位',
    invalid: '儲存的值 %{value} 不是 1 或 2',
  },
  timezone: {
    updated: '時區更新成功',
    updateFailed: '時區更新失敗',
    currentTime: '當前時間',
  },
  errors: {
    loadFailed: '載入設定失敗',
    updateFailed: '更新設定失敗',
    uploadFailed: '上傳標誌失敗',
  },
};